import { ɵɵdefineInjectable, Injectable, Component, Input, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function NgxCaptchaComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2)(1, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxCaptchaComponent_div_2_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.captch_input = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "input", 4);
    ɵngcc0.ɵɵlistener("click", function NgxCaptchaComponent_div_2_Template_input_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.checkCaptcha()); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 5);
    ɵngcc0.ɵɵlistener("click", function NgxCaptchaComponent_div_2_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.playCaptcha()); });
    ɵngcc0.ɵɵtext(4, "\uD83D\uDD08");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "a", 6);
    ɵngcc0.ɵɵlistener("click", function NgxCaptchaComponent_div_2_Template_a_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.createCaptcha()); });
    ɵngcc0.ɵɵtext(6, "\u21BB");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.captch_input);
} }
class NgxCaptchaService {
    constructor() {
        this.captchSource = new BehaviorSubject(null);
        this.captchStatus = this.captchSource.asObservable();
    }
    setCaptchaStatus(code) {
        this.captchSource.next(code);
    }
    generateCaptchaCode(textType = 'AN', length = 6, textCase = 'U') {
        const codeObj = {
            N: '1234567890',
            C: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        };
        let codeStr = '';
        switch (textType) {
            case 'AN':
                codeStr = codeObj.N;
                switch (textCase) {
                    case 'U':
                        codeStr += codeObj.C;
                        break;
                    case 'L':
                        codeStr += codeObj.C.toLowerCase();
                        break;
                    case 'M':
                        codeStr += codeObj.C.slice(0, 13) + codeObj.C.slice(3, 26).toLowerCase();
                        break;
                }
                break;
            case 'N':
                codeStr = codeObj.N;
                break;
            case 'C':
                codeStr = codeObj.C;
                break;
        }
        let code = '';
        for (let i = 0; i < length; i++) {
            code += codeStr.charAt(Math.floor(Math.random() * codeStr.length));
        }
        return code;
    }
}
NgxCaptchaService.ɵfac = function NgxCaptchaService_Factory(t) { return new (t || NgxCaptchaService)(); };
/** @nocollapse */ NgxCaptchaService.ɵprov = ɵɵdefineInjectable({ factory: function NgxCaptchaService_Factory() { return new NgxCaptchaService(); }, token: NgxCaptchaService, providedIn: "root" });
/** @nocollapse */
NgxCaptchaService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCaptchaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgxCaptchaComponent {
    constructor(captchService) {
        this.captchService = captchService;
        this.config = {};
        this.captch_input = null;
        this.code = null;
        this.resultCode = null;
    }
    ngOnChanges() {
        if (this.config) {
            this.config.font.size = (this.config.font && this.config.font.size) ? this.config.font.size : '40px';
            this.config.font.family = (this.config.font && this.config.font.family) ? this.config.font.family : 'sans-serif';
            this.config.textType = (this.config.textType) ? this.config.textType : 'AN';
            this.config.length = (this.config.length) ? this.config.length : 6;
            this.config.cssClass = (this.config.cssClass) ? this.config.cssClass : '';
            this.config.type = (this.config.type) ? Number(this.config.type) : 1;
            this.config.back.stroke = (this.config.back && this.config.back.stroke) ? this.config.back.stroke : '';
            this.config.back.solid = (this.config.back && this.config.back.solid) ? this.config.back.solid : '#fbfbfb';
            this.config.textType = (this.config.textType) ? this.config.textType : 'AN';
            this.config.textCase = (this.config.textCase) ? this.config.textCase : 'U';
            this.createCaptcha();
        }
    }
    createCaptcha() {
        switch (this.config.type) {
            case 1:
                this.code = this.resultCode = this.captchService.generateCaptchaCode(this.config.textType, this.config.length, this.config.textCase);
                break;
            case 2:
                const num1 = Math.floor(Math.random() * 99);
                const num2 = Math.floor(Math.random() * 9);
                const operators = ['+', '-'];
                const operator = operators[(Math.floor(Math.random() * operators.length))];
                this.code = num1 + operator + num2 + '=?';
                this.resultCode = (operator === '+') ? (num1 + num2) : (num1 - num2);
                break;
            case 3:
                break;
        }
        setTimeout(() => {
            const captcahCanvas = document.getElementById('captcahCanvas');
            const ctx = captcahCanvas.getContext('2d');
            ctx.fillStyle = this.config.back.solid;
            ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);
            // ctx.font = '10px Arial';
            // ctx.fillStyle = "#000000";
            // ctx.fillText("Powered By BinsSoft", captcahCanvas.width - 95, captcahCanvas.height - 5);
            ctx.beginPath();
            if (this.config.type !== 3) {
                captcahCanvas.style.letterSpacing = 15 + 'px';
                ctx.font = this.config.font.size + ' ' + this.config.font.family;
                ctx.fillStyle = this.config.font.color;
                ctx.textBaseline = 'middle';
                if (this.config.type == 1) {
                    const yAxix = [50, 30, 60, 40];
                    Array.from(this.code).forEach((c, i) => {
                        const y = yAxix[Math.floor(Math.random() * yAxix.length)];
                        ctx.fillText(c, (i + 1) * 40, y);
                    });
                }
                else {
                    ctx.fillText(this.code, 40, 50);
                }
                if (this.config.back.stroke) {
                    ctx.strokeStyle = this.config.back.stroke;
                    for (let i = 0; i < 150; i++) {
                        ctx.moveTo(Math.random() * 300, Math.random() * 300);
                        ctx.lineTo(Math.random() * 300, Math.random() * 300);
                    }
                    ctx.stroke();
                }
            }
            else {
                ctx.fillStyle = '#000';
                const position = {
                    x: 20,
                    y: 20,
                    width: 30,
                    height: 30,
                    thickness: 1
                };
                ctx.fillRect(position.x - (position.thickness), position.y - (position.thickness), position.width + (position.thickness * 2), position.height + (position.thickness * 2));
                ctx.fillStyle = '#FFF';
                ctx.fillRect(position.x, position.y, position.width, position.height);
                ctx.font = '15px ' + this.config.font.family;
                ctx.fillStyle = this.config.font.color;
                ctx.fillText('I\'m not a robot', (position.x) + position.width + 5, (position.y * 2));
                captcahCanvas.addEventListener('mousedown', (e) => {
                    const clickPosition = this.getMousePosition(captcahCanvas, e);
                    const midOfBox = {
                        x: position.x + position.width / 2,
                        y: position.y + position.height / 2
                    };
                    this.resultCode = 1;
                    if (Math.abs(clickPosition.x - midOfBox.x) <= 5 &&
                        Math.abs(clickPosition.y - midOfBox.y) <= 5) { /// it is a robot
                        this.captch_input = 0;
                    }
                    else { // it is a human
                        if ((clickPosition.x >= position.x && clickPosition.x <= (position.x + position.width)) &&
                            (clickPosition.y >= position.y && clickPosition.y <= (position.y + position.height))) {
                            this.captch_input = 1;
                            ctx.font = '30px ' + this.config.font.family;
                            ctx.fillText('✔', position.x, position.y + position.height - 5);
                        }
                    }
                    this.checkCaptcha();
                });
            }
        }, 100);
    }
    playCaptcha() {
        const msg = new SpeechSynthesisUtterance(this.code.split('').join(' '));
        msg.pitch = 1;
        window.speechSynthesis.speak(msg);
    }
    checkCaptcha() {
        if (this.captch_input !== this.resultCode) {
            this.captchService.setCaptchaStatus(false);
        }
        else {
            this.captchService.setCaptchaStatus(true);
        }
    }
    getMousePosition(canvas, event) {
        const rect = canvas.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        return {
            x,
            y
        };
    }
}
NgxCaptchaComponent.ɵfac = function NgxCaptchaComponent_Factory(t) { return new (t || NgxCaptchaComponent)(ɵngcc0.ɵɵdirectiveInject(NgxCaptchaService)); };
NgxCaptchaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxCaptchaComponent, selectors: [["ngx-captcha"]], inputs: { config: "config" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [["id", "captcahCanvas", "width", "316", "height", "80"], ["class", "captcha-actions", 4, "ngIf"], [1, "captcha-actions"], ["type", "text", 3, "ngModel", "ngModelChange"], ["type", "button", "value", "Check", 3, "click"], ["href", "javascript:void(0)", 1, "cpt-btn", 3, "click"], ["href", "javascript:void(0)", 1, "cpt-btn", "reload", 3, "click"]], template: function NgxCaptchaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "canvas", 0);
        ɵngcc0.ɵɵtemplate(2, NgxCaptchaComponent_div_2_Template, 7, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("captcha-container ", ctx.config.cssClass, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.type != 3);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: [".captcha-container[_ngcontent-%COMP%]{width:315px;box-shadow:1px 1px 1px 0 #ccc}.captcha-actions[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{padding:5px;border:1px solid #ccc;border-radius:10px 0 0 10px;outline:none}.captcha-actions[_ngcontent-%COMP%]   input[type=button][_ngcontent-%COMP%]{outline:none;padding:6px;border:none;background:#ccc;border-radius:0 10px 10px 0}.captcha-actions[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding:10px;cursor:pointer;font-size:15px;font-weight:700;text-decoration:none;color:#222}.captcha-container[_ngcontent-%COMP%]   .powered-by[_ngcontent-%COMP%]{font-size:11px;font-family:Arial;color:#ccc;padding:5px;display:block!important}"] });
/** @nocollapse */
NgxCaptchaComponent.ctorParameters = () => [
    { type: NgxCaptchaService }
];
NgxCaptchaComponent.propDecorators = {
    config: [{ type: Input, args: ['config',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCaptchaComponent, [{
        type: Component,
        args: [{ selector: 'ngx-captcha', template: "<div class=\"captcha-container {{ config.cssClass}}\">\r\n    <canvas id=\"captcahCanvas\" width=\"316\" height=\"80\"></canvas>\r\n    \r\n\r\n    <div class=\"captcha-actions\" *ngIf=\"config.type != 3\">\r\n  <input type=\"text\" [(ngModel)]=\"captch_input\" />\r\n  <input type=\"button\" value=\"Check\" (click)=\"checkCaptcha()\" />\r\n  <a href=\"javascript:void(0)\" class=\"cpt-btn\" (click)=\"playCaptcha()\">\uD83D\uDD08</a>\r\n    <a href=\"javascript:void(0)\" class=\"cpt-btn reload\" (click)=\"createCaptcha()\">&#x21bb;</a>\r\n</div>\r\n</div>", styles: [".captcha-container{width:315px;box-shadow:1px 1px 1px 0 #ccc}.captcha-actions input[type=text]{padding:5px;border:1px solid #ccc;border-radius:10px 0 0 10px;outline:none}.captcha-actions input[type=button]{outline:none;padding:6px;border:none;background:#ccc;border-radius:0 10px 10px 0}.captcha-actions a{padding:10px;cursor:pointer;font-size:15px;font-weight:700;text-decoration:none;color:#222}.captcha-container .powered-by{font-size:11px;font-family:Arial;color:#ccc;padding:5px;display:block!important}"] }]
    }], function () { return [{ type: NgxCaptchaService }]; }, { config: [{
            type: Input,
            args: ['config']
        }] }); })();

class NgxCaptchaModule {
    static forRoot() {
        return {
            ngModule: NgxCaptchaModule,
            providers: [NgxCaptchaService]
        };
    }
}
NgxCaptchaModule.ɵfac = function NgxCaptchaModule_Factory(t) { return new (t || NgxCaptchaModule)(); };
NgxCaptchaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCaptchaModule });
NgxCaptchaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [BrowserModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCaptchaModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxCaptchaComponent],
                imports: [
                    BrowserModule,
                    FormsModule
                ],
                exports: [NgxCaptchaComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCaptchaModule, { declarations: function () { return [NgxCaptchaComponent]; }, imports: function () { return [BrowserModule,
        FormsModule]; }, exports: function () { return [NgxCaptchaComponent]; } }); })();

/*
 * Public API Surface of ngx-captcha
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCaptchaComponent, NgxCaptchaModule, NgxCaptchaService };

